module.exports = __webpack_public_path__ + "static/media/uic_logo.fb593e65.svg";